import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { calloutConfig, tokens } from '../../constants';
import { fitContentWidth } from '../../utils';
export var getCalloutStyles = props => {
  var _a, _b, _c, _d;
  var config = props.config,
    state = props.state,
    version = props.version,
    width = props.width;
  var backgroundColor = (_b = (_a = config === null || config === void 0 ? void 0 : config.state) === null || _a === void 0 ? void 0 : _a[state]) === null || _b === void 0 ? void 0 : _b.backgroundColor;
  var borderColor = (_d = (_c = config === null || config === void 0 ? void 0 : config.state) === null || _c === void 0 ? void 0 : _c[state]) === null || _d === void 0 ? void 0 : _d.borderColor;
  var paddingHorizontal = tokens.spacing.SPACING_12;
  var paddingVertical = tokens.spacing.SPACING_8;
  var borderRadius = tokens.borderRadius.BORDER_RADIUS_8;
  return StyleSheet.create({
    container: Object.assign({
      backgroundColor,
      paddingHorizontal,
      paddingVertical,
      borderRadius,
      borderColor,
      borderWidth: 1,
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'row',
      width
    }, version === 'fixed-padding' && Object.assign({}, fitContentWidth())),
    calloutContainer: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1
    },
    contentContainer: {
      flex: 1,
      justifyContent: 'flex-start'
    },
    iconStyles: {
      marginRight: tokens.spacing.SPACING_6
    }
  });
};
export var getCalloutProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(calloutConfig === null || calloutConfig === void 0 ? void 0 : calloutConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.callout) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};